export enum BASELINE_REWARD_SETTINGS_ENUM {
  LOCATION = 'Location-Level Baseline',
  OWNER = 'Practice-Level Baseline'
}
